import { createContext, useContext, useMemo, type ReactNode } from "react";

export interface ConfirmOptions {
  title: string;
  description?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  colorPalette?: "brand" | "red" | "green";
}

export type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>;

export const ConfirmContext = createContext<ConfirmFn | null>(null);

export const useConfirm = (): ConfirmFn => {
  const confirm = useContext(ConfirmContext);
  if (!confirm) {
    throw new Error("useConfirm debe usarse dentro de ConfirmProvider");
  }
  return confirm;
};

export const useConfirmToggle = () => {
  const confirm = useConfirm();
  return useMemo(
    () => (currentlyEnabled: boolean, entity: string) =>
      currentlyEnabled
        ? confirm({
            title: `¿Deshabilitar ${entity}?`,
            description:
              "Dejará de aparecer en las listas y no podrá usarse hasta que lo habilites de nuevo.",
            confirmLabel: "Deshabilitar",
            colorPalette: "red",
          })
        : confirm({
            title: `¿Habilitar ${entity}?`,
            description: "Volverá a estar disponible para su uso.",
            confirmLabel: "Habilitar",
            colorPalette: "brand",
          }),
    [confirm],
  );
};
